import { render, staticRenderFns } from "./CheckDetalleViaje.vue?vue&type=template&id=c641a1a6&"
import script from "./CheckDetalleViaje.vue?vue&type=script&lang=ts&"
export * from "./CheckDetalleViaje.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c641a1a6', component.options)
    } else {
      api.reload('c641a1a6', component.options)
    }
    module.hot.accept("./CheckDetalleViaje.vue?vue&type=template&id=c641a1a6&", function () {
      api.rerender('c641a1a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Informes/InformeDetalleViaje/CheckDetalleViaje.vue"
export default component.exports